import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M227 10643 c-4 -3 -7 -29 -7 -56 0 -43 2 -48 15 -37 8 7 15 19 15 26
0 7 11 21 25 30 36 24 32 44 -8 44 -19 0 -37 -3 -40 -7z"
          />
          <path
            d="M10500 10640 c0 -6 13 -25 29 -41 40 -39 53 -37 49 9 -3 35 -5 37
-40 40 -24 2 -38 -1 -38 -8z"
          />
          <path
            d="M5010 10470 c-52 -5 -130 -11 -172 -14 -43 -2 -82 -7 -88 -11 -5 -3
-42 -10 -82 -15 -112 -15 -236 -36 -308 -53 -36 -8 -94 -21 -130 -28 -36 -6
-73 -16 -83 -21 -10 -5 -30 -11 -45 -13 -15 -2 -66 -15 -115 -29 -48 -14 -95
-26 -105 -26 -10 0 -22 -4 -27 -8 -18 -15 -115 -44 -129 -39 -8 3 -25 -2 -38
-13 -13 -10 -59 -32 -103 -50 -98 -40 -127 -52 -187 -79 -26 -12 -51 -21 -55
-21 -13 0 -212 -101 -219 -111 -3 -5 -12 -9 -20 -9 -9 0 -45 -17 -81 -37 -113
-65 -157 -91 -193 -111 -19 -10 -65 -38 -102 -60 -37 -23 -72 -42 -78 -42 -5
0 -10 -4 -10 -8 0 -4 -26 -23 -57 -42 -32 -19 -65 -41 -73 -48 -8 -7 -64 -49
-125 -94 -60 -44 -117 -87 -125 -94 -8 -8 -35 -30 -60 -49 -58 -45 -122 -102
-220 -195 -44 -41 -99 -93 -122 -115 -65 -61 -222 -232 -335 -365 -16 -19 -65
-82 -109 -140 -43 -58 -85 -111 -92 -119 -8 -8 -25 -33 -39 -55 -14 -23 -43
-64 -64 -92 -22 -28 -39 -54 -39 -58 0 -4 -19 -35 -42 -69 -49 -71 -107 -173
-208 -372 -103 -202 -114 -220 -130 -220 -9 0 -14 -8 -12 -20 7 -41 2 -65 -23
-109 -14 -25 -25 -50 -25 -56 0 -6 -9 -30 -20 -52 -11 -23 -20 -45 -20 -49 0
-3 -12 -33 -27 -65 -25 -53 -35 -87 -62 -206 -4 -21 -13 -43 -18 -50 -6 -7
-16 -38 -23 -68 -7 -30 -24 -91 -36 -136 -13 -44 -24 -91 -24 -104 0 -14 -9
-54 -19 -90 -36 -124 -72 -327 -77 -435 -1 -33 -7 -84 -13 -114 -6 -29 -8 -63
-5 -75 3 -12 0 -51 -7 -86 -14 -78 -21 -572 -8 -615 5 -16 15 -124 24 -240 13
-193 28 -292 55 -385 5 -19 10 -51 10 -71 0 -20 9 -56 20 -80 12 -27 20 -66
20 -99 0 -31 4 -60 8 -65 14 -17 40 -97 51 -159 6 -32 18 -72 26 -89 8 -16 15
-39 15 -49 0 -10 6 -31 14 -46 14 -29 28 -101 27 -143 0 -17 6 -29 17 -32 9
-2 25 -22 36 -43 10 -22 22 -47 27 -56 5 -10 9 -24 9 -32 0 -8 22 -62 50 -120
27 -58 50 -108 50 -111 0 -5 87 -192 101 -215 4 -8 26 -45 47 -81 21 -36 42
-77 46 -92 3 -15 19 -41 35 -59 15 -18 38 -52 49 -75 12 -23 35 -62 52 -86 16
-25 30 -48 30 -53 0 -4 10 -18 22 -31 19 -21 21 -27 9 -44 -15 -25 -8 -34 27
-34 21 0 31 -8 47 -40 11 -22 25 -44 31 -50 9 -9 71 -86 99 -123 6 -8 27 -32
47 -55 38 -41 42 -51 38 -96 -2 -20 2 -23 23 -17 21 5 36 -7 108 -84 153 -164
183 -196 244 -250 33 -30 68 -67 78 -83 9 -15 30 -34 47 -40 16 -7 47 -34 70
-60 23 -26 46 -47 51 -47 5 0 24 -16 41 -35 17 -20 45 -42 63 -49 17 -8 54
-35 81 -62 28 -27 73 -62 100 -79 27 -16 65 -43 84 -60 19 -16 51 -39 70 -49
19 -11 53 -31 74 -45 22 -14 67 -41 100 -59 33 -18 64 -39 70 -47 6 -8 52 -33
101 -56 50 -23 101 -50 114 -60 13 -11 31 -19 41 -19 9 0 28 -9 41 -21 13 -11
52 -34 87 -49 34 -16 69 -36 78 -44 8 -9 28 -16 43 -16 16 0 40 -9 54 -20 14
-11 31 -20 39 -20 7 0 34 -11 60 -25 26 -14 61 -25 78 -25 18 0 43 -9 57 -20
14 -11 31 -20 38 -20 6 0 36 -13 66 -30 32 -18 69 -30 91 -30 20 0 40 -4 43
-10 3 -5 14 -10 24 -10 9 0 35 -8 57 -18 21 -10 66 -25 99 -32 33 -7 66 -18
72 -23 7 -5 22 -7 33 -4 11 3 41 -2 67 -10 27 -9 68 -19 93 -24 25 -5 92 -18
150 -29 169 -32 229 -41 325 -51 50 -4 119 -13 155 -19 102 -16 500 -27 665
-18 83 4 197 10 255 13 58 4 114 10 125 15 11 5 49 11 85 14 131 12 217 24
315 46 55 12 120 25 145 29 25 4 50 10 57 14 6 4 37 11 70 16 81 12 180 39
230 62 24 10 52 19 63 19 11 0 20 5 20 10 0 6 18 10 40 10 25 0 60 11 95 30
30 17 62 30 70 30 8 0 29 9 47 20 18 11 42 20 53 20 11 0 38 9 60 19 121 58
152 71 170 71 11 1 38 12 60 25 22 14 51 30 65 35 13 6 50 27 81 46 31 18 64
34 72 34 9 0 28 11 44 24 15 13 39 27 53 31 14 4 30 12 36 17 7 4 34 20 60 34
27 14 63 33 79 42 17 9 36 22 43 29 7 7 19 13 25 13 7 0 30 15 52 33 40 32
116 87 213 153 30 20 62 44 72 54 9 9 44 37 76 61 33 24 61 47 62 52 2 4 8 7
14 7 17 0 141 108 292 255 51 50 123 117 159 150 36 33 71 70 79 82 16 27 151
184 196 229 17 18 32 36 32 39 0 4 15 25 33 46 28 33 67 86 182 249 14 19 33
48 42 64 10 16 32 50 49 76 18 25 42 70 54 98 12 29 25 52 29 52 3 0 12 13 19
29 7 16 22 39 32 51 11 13 20 32 20 43 0 11 10 34 23 51 13 17 36 60 52 96 15
36 39 82 52 102 12 21 23 44 23 53 0 8 9 32 20 52 11 21 20 45 20 53 0 9 4 20
8 26 9 10 46 102 48 119 0 6 4 17 7 25 23 58 101 292 107 325 5 22 18 74 30
115 12 41 26 93 30 115 5 22 13 57 19 78 26 91 31 117 37 192 3 43 10 87 15
97 5 9 9 35 9 58 0 23 5 60 10 83 6 23 14 105 20 182 5 77 14 183 20 235 15
145 11 549 -6 582 -9 17 -14 64 -15 130 0 57 -5 128 -10 158 -5 30 -13 94 -19
142 -5 48 -16 114 -25 147 -8 32 -15 76 -15 97 -1 22 -7 50 -15 64 -8 14 -14
43 -15 65 0 22 -11 73 -24 115 -14 41 -29 93 -35 115 -17 69 -93 310 -101 320
-4 6 -20 51 -35 100 -15 50 -31 97 -36 105 -36 65 -47 90 -53 123 -4 20 -11
37 -15 37 -5 0 -21 35 -36 78 -16 42 -32 79 -35 82 -16 11 -80 146 -80 167 0
13 -9 28 -20 35 -11 7 -20 18 -20 25 0 7 -4 13 -8 13 -5 0 -17 18 -27 40 -10
22 -24 45 -32 51 -7 6 -13 20 -13 29 0 10 -4 20 -8 22 -5 2 -23 30 -42 62 -18
33 -40 67 -47 75 -8 9 -56 79 -106 156 -51 77 -106 157 -122 179 -120 155
-217 271 -275 331 -250 256 -431 431 -535 516 -66 55 -137 115 -158 134 -22
19 -45 35 -52 35 -7 0 -15 4 -17 8 -4 11 -234 172 -287 201 -14 8 -30 20 -36
28 -5 7 -26 21 -45 32 -59 31 -141 76 -220 120 -111 61 -389 196 -435 211 -22
7 -44 16 -49 21 -6 5 -18 9 -29 9 -10 0 -35 9 -55 20 -67 35 -151 70 -184 77
-18 3 -37 9 -43 13 -10 7 -82 29 -230 70 -44 12 -84 26 -90 31 -5 5 -24 9 -42
9 -19 0 -50 7 -70 15 -19 8 -48 15 -63 15 -15 0 -56 9 -90 20 -34 11 -82 20
-105 20 -23 0 -58 6 -77 14 -19 8 -74 18 -124 22 -49 4 -100 11 -114 17 -59
23 -737 43 -920 27z m745 -36 c195 -17 380 -40 394 -48 6 -4 50 -13 98 -21 86
-14 142 -26 273 -59 98 -25 170 -45 220 -61 25 -8 53 -15 63 -15 9 0 25 -5 35
-11 9 -5 60 -25 112 -43 52 -18 111 -39 130 -46 19 -7 44 -16 55 -20 125 -47
483 -216 595 -281 30 -18 74 -43 98 -55 23 -13 67 -40 97 -59 31 -19 58 -35
61 -35 5 0 186 -121 194 -131 3 -3 28 -21 55 -39 68 -46 315 -243 400 -320
102 -91 321 -308 386 -381 32 -35 70 -77 86 -94 33 -35 182 -217 202 -248 8
-12 25 -33 37 -47 49 -56 271 -398 345 -532 75 -134 211 -409 252 -508 67
-163 106 -265 112 -297 4 -18 11 -33 16 -33 5 0 9 -8 9 -17 1 -10 8 -36 16
-58 27 -73 99 -333 116 -420 5 -27 16 -70 23 -95 8 -25 19 -76 24 -115 6 -38
15 -90 20 -115 6 -25 10 -65 11 -90 0 -25 7 -70 15 -100 33 -117 52 -624 36
-905 -7 -110 -14 -222 -15 -250 -2 -27 -10 -88 -19 -135 -9 -47 -21 -119 -26
-160 -21 -150 -40 -255 -50 -275 -5 -11 -14 -45 -19 -75 -6 -30 -22 -97 -36
-148 -14 -51 -26 -102 -26 -113 0 -10 -9 -36 -20 -56 -11 -21 -20 -50 -20 -65
0 -15 -4 -29 -9 -32 -5 -3 -12 -18 -15 -33 -7 -28 -11 -39 -90 -243 -65 -170
-165 -378 -265 -555 -28 -49 -51 -96 -51 -102 0 -7 -4 -13 -10 -13 -5 0 -25
-28 -45 -63 -30 -52 -164 -248 -192 -282 -5 -5 -35 -44 -66 -85 -91 -117 -125
-160 -186 -230 -84 -96 -377 -386 -466 -460 -43 -36 -99 -83 -125 -105 -27
-22 -70 -55 -97 -74 -26 -19 -52 -40 -58 -46 -5 -6 -46 -35 -90 -65 -44 -29
-83 -57 -86 -62 -3 -5 -41 -31 -85 -58 -43 -27 -84 -53 -90 -57 -11 -9 -35
-23 -93 -55 -20 -11 -44 -27 -53 -36 -10 -8 -18 -11 -18 -6 0 5 -4 5 -8 -1 -9
-12 -38 -29 -172 -97 -58 -30 -114 -59 -125 -65 -27 -15 -113 -53 -120 -53 -4
0 -32 -13 -63 -28 -31 -15 -77 -34 -102 -42 -25 -8 -51 -20 -57 -26 -7 -7 -30
-15 -52 -19 -22 -4 -45 -13 -52 -21 -6 -8 -29 -17 -51 -20 -21 -4 -41 -11 -44
-15 -3 -5 -14 -9 -25 -9 -10 0 -27 -4 -37 -9 -32 -18 -247 -82 -292 -88 -25
-3 -49 -9 -55 -13 -12 -8 -67 -22 -180 -45 -44 -8 -94 -20 -111 -25 -17 -6
-45 -10 -63 -10 -18 0 -41 -4 -51 -10 -10 -5 -42 -12 -72 -14 -52 -3 -253 -26
-413 -46 -186 -24 -739 -15 -756 11 -7 11 -11 11 -17 1 -6 -8 -21 -11 -43 -7
-19 3 -50 7 -69 10 -19 2 -48 7 -65 10 -26 4 -209 29 -315 42 -19 2 -44 8 -55
12 -18 8 -44 13 -182 37 -18 4 -33 10 -33 14 0 5 -9 6 -19 3 -10 -3 -29 1 -42
8 -13 7 -39 14 -57 15 -18 2 -48 8 -65 14 -18 5 -115 37 -217 70 -102 34 -198
67 -215 74 -16 7 -64 26 -105 42 -41 16 -77 31 -80 35 -3 3 -16 10 -30 14 -40
12 -159 67 -240 110 -14 7 -41 20 -60 30 -19 9 -57 29 -85 45 -27 16 -75 42
-105 58 -86 45 -319 190 -374 234 -16 13 -44 32 -61 43 -40 25 -318 243 -366
287 -20 18 -69 62 -109 98 -97 87 -237 227 -324 325 -39 44 -76 85 -82 90 -15
13 -126 152 -184 230 -25 33 -48 62 -51 65 -6 5 -202 297 -238 355 -51 83
-123 212 -176 320 -33 66 -62 122 -65 125 -7 7 -66 141 -112 255 -22 55 -49
118 -59 140 -9 22 -25 65 -34 95 -9 30 -25 75 -34 100 -20 50 -25 68 -75 250
-33 120 -63 252 -85 370 -39 209 -44 245 -72 510 -16 153 -16 692 0 840 33
292 63 497 90 605 6 22 20 83 32 135 11 52 29 122 40 155 81 264 115 365 155
465 25 63 53 133 61 154 8 22 43 100 79 173 35 74 64 136 64 138 0 2 15 30 33
62 19 32 60 105 92 163 84 150 236 378 350 526 214 277 475 555 700 747 38 33
84 71 100 86 66 57 224 175 320 241 44 30 82 58 83 62 2 4 8 8 13 8 5 0 61 34
126 76 64 42 127 80 139 85 13 4 42 20 64 34 68 43 355 183 530 258 19 9 67
27 105 40 39 14 115 42 170 62 55 20 132 44 170 55 39 10 113 31 165 45 221
62 503 112 805 144 124 13 682 10 850 -5z"
          />
          <path
            d="M5363 10053 c-41 -5 -40 -3 -47 -215 -6 -221 -15 -210 163 -206 115
3 135 6 145 21 8 12 8 22 0 35 -9 14 -30 18 -108 22 -96 5 -115 13 -116 47 0
38 11 43 104 43 98 0 116 7 116 47 0 27 -16 32 -124 35 -90 3 -109 17 -88 62
11 25 14 26 111 26 85 0 102 3 109 18 6 9 6 27 1 40 -8 20 -15 22 -86 22 -43
0 -94 2 -113 4 -19 2 -50 2 -67 -1z"
          />
          <path
            d="M5729 10013 c-9 -23 -21 -112 -46 -319 -7 -61 -5 -63 92 -80 148 -27
222 -14 196 35 -12 22 -24 26 -95 36 -85 12 -96 19 -96 65 0 23 7 85 16 139
21 122 15 151 -26 151 -24 0 -33 -6 -41 -27z"
          />
          <path
            d="M4753 10004 c-3 -8 -2 -41 2 -72 12 -86 11 -115 -3 -119 -6 -3 -54
36 -106 86 -91 88 -115 101 -145 82 -16 -10 -16 -72 -1 -176 5 -33 14 -94 20
-135 13 -89 27 -109 65 -92 l26 12 -7 104 c-4 70 -3 105 4 110 6 4 57 -39 114
-94 104 -102 129 -114 152 -78 7 12 6 45 -7 120 -9 57 -20 130 -23 163 -10 89
-18 105 -54 105 -19 0 -33 -6 -37 -16z"
          />
          <path
            d="M6095 9973 c-7 -19 -18 -66 -39 -173 -7 -36 -19 -86 -26 -111 -15
-50 -8 -94 15 -103 8 -3 67 -17 130 -31 129 -29 159 -25 153 22 -2 22 -12 30
-53 44 -27 10 -65 18 -82 18 -30 1 -73 30 -73 49 0 5 6 17 14 27 14 19 16 19
100 2 92 -19 126 -13 126 22 0 26 -16 35 -95 55 -38 10 -78 20 -87 23 -23 6
-24 55 -3 73 12 10 25 10 58 1 128 -35 173 -30 165 19 -4 30 -14 34 -125 59
-115 26 -168 27 -178 4z"
          />
          <path
            d="M4160 9958 c-58 -17 -107 -63 -129 -124 -26 -68 -26 -90 -1 -161 34
-98 97 -143 197 -143 111 1 191 62 214 164 11 49 10 64 -7 118 -38 126 -145
183 -274 146z m113 -77 c85 -32 117 -163 56 -227 -71 -75 -192 -44 -219 57
-20 75 3 132 63 160 48 21 65 23 100 10z"
          />
          <path
            d="M6525 9858 c-45 -24 -71 -53 -102 -117 -71 -144 39 -300 212 -302 62
-1 85 12 85 47 0 30 -11 35 -74 38 -117 5 -175 75 -145 174 16 51 48 79 103
92 32 7 46 4 99 -24 65 -34 91 -36 102 -8 9 25 -25 64 -85 95 -67 34 -137 36
-195 5z"
          />
          <path
            d="M3828 9839 c-10 -5 -18 -17 -18 -26 0 -28 102 -327 118 -346 24 -27
66 -19 70 13 3 35 -103 341 -124 357 -21 15 -24 15 -46 2z"
          />
          <path
            d="M3625 9764 c-83 -36 -116 -50 -147 -63 -37 -14 -51 -43 -34 -67 13
-17 18 -17 65 -5 38 10 55 10 65 2 8 -6 31 -58 52 -114 47 -125 70 -167 94
-167 16 0 50 24 50 36 0 6 -69 182 -86 221 -26 58 -19 80 32 102 40 18 45 24
42 48 -3 24 -8 28 -38 31 -21 1 -59 -9 -95 -24z"
          />
          <path
            d="M6855 9751 c-9 -29 3 -46 50 -69 25 -12 45 -27 45 -34 0 -6 -22 -69
-50 -140 -27 -70 -50 -137 -50 -148 0 -22 34 -44 56 -36 15 6 38 52 80 161 48
127 55 137 84 130 76 -19 89 -18 101 9 8 16 9 30 3 35 -15 15 -267 111 -290
111 -13 0 -25 -8 -29 -19z"
          />
          <path
            d="M4947 9703 c-11 -10 -8 -49 5 -78 15 -34 49 -30 62 7 13 38 -6 78
-37 78 -13 0 -27 -3 -30 -7z"
          />
          <path
            d="M3172 9563 c-119 -60 -120 -66 -57 -187 26 -50 63 -121 81 -158 36
-70 59 -87 94 -68 24 13 25 35 5 73 -19 37 -7 60 43 86 76 39 112 87 112 149
0 52 -19 91 -60 126 -50 41 -105 36 -218 -21z m174 -60 c17 -22 17 -63 1 -83
-18 -24 -82 -60 -104 -60 -24 0 -70 78 -60 103 9 23 75 55 116 56 21 1 39 -5
47 -16z"
          />
          <path
            d="M7249 9583 c-9 -10 -30 -47 -48 -83 -18 -36 -51 -98 -73 -138 -49
-91 -50 -135 -3 -140 26 -2 33 3 50 34 28 52 49 63 73 40 21 -18 52 -100 52
-136 0 -29 44 -70 76 -70 23 0 25 3 19 27 -15 60 -22 112 -16 121 3 5 23 12
43 16 24 4 47 19 67 42 27 30 31 42 31 93 0 52 -4 62 -32 93 -33 35 -180 118
-209 118 -9 0 -22 -8 -30 -17z m121 -118 c75 -38 89 -86 35 -121 -20 -13 -27
-13 -66 2 -53 21 -79 41 -79 63 0 21 37 81 50 81 6 0 33 -11 60 -25z"
          />
          <path
            d="M2946 9434 c-23 -22 -20 -39 19 -105 19 -33 35 -62 35 -64 0 -3 20
-38 44 -79 24 -41 47 -84 51 -95 11 -36 85 -18 85 21 0 11 -58 122 -108 206
-18 29 -32 56 -32 59 0 14 -52 73 -65 73 -7 0 -21 -7 -29 -16z"
          />
          <path
            d="M7603 9408 c-6 -7 -41 -68 -79 -136 -38 -68 -78 -139 -88 -157 -19
-34 -19 -35 -1 -55 33 -36 60 -26 96 38 57 101 65 116 109 200 41 80 42 83 25
102 -21 23 -48 26 -62 8z"
          />
          <path
            d="M2750 9323 c-85 -44 -161 -99 -166 -120 -4 -15 4 -38 24 -70 17 -27
46 -72 64 -102 18 -30 41 -66 50 -80 10 -14 23 -36 29 -47 13 -24 47 -43 67
-37 31 11 34 43 8 87 -23 39 -24 45 -10 64 18 26 54 28 114 7 54 -19 114 -19
130 0 22 26 7 48 -41 60 -70 18 -71 19 -63 84 7 64 -5 98 -50 140 -35 32 -108
39 -156 14z m110 -104 c11 -27 11 -34 -7 -57 -11 -15 -39 -38 -63 -51 l-43
-24 -24 29 c-36 45 -30 74 20 106 23 15 56 28 73 28 26 0 34 -6 44 -31z"
          />
          <path
            d="M7755 9260 c-41 -13 -86 -56 -118 -111 -45 -76 -34 -179 24 -240 51
-53 88 -72 148 -73 53 -1 56 0 59 25 4 30 -9 41 -65 57 -58 17 -103 70 -103
123 0 81 53 139 127 139 24 0 54 -5 66 -11 25 -13 77 -67 77 -81 0 -5 15 -8
33 -6 43 4 48 37 12 88 -43 62 -94 92 -167 96 -35 2 -76 -1 -93 -6z"
          />
          <path
            d="M5385 9133 c-26 -4 -14 -11 85 -49 177 -68 224 -91 311 -151 184
-127 303 -280 360 -464 20 -62 24 -97 24 -219 1 -80 3 -152 6 -160 3 -10 -2
-14 -15 -12 -44 8 -68 24 -80 54 l-14 31 -88 3 c-49 2 -114 7 -144 11 -51 7
-55 10 -52 33 1 14 4 66 5 115 2 85 0 94 -33 157 -133 258 -423 414 -733 393
-54 -3 -131 -15 -172 -25 -157 -40 -345 -160 -345 -220 0 -14 -10 -25 -29 -33
-36 -15 -59 -44 -97 -122 -27 -56 -29 -67 -28 -176 l1 -116 -86 -8 c-92 -8
-155 -8 -184 1 -26 8 -39 50 -31 100 3 23 3 51 -1 63 -21 66 -43 -37 -25 -119
25 -122 26 -115 -19 -134 -56 -22 -64 -21 -50 6 8 15 13 79 14 178 1 139 3
162 27 225 78 214 226 374 483 521 46 27 48 29 24 32 -25 3 -172 -28 -229 -47
-14 -5 -59 -19 -100 -32 -166 -49 -276 -92 -465 -179 -247 -113 -546 -296
-735 -450 -24 -19 -70 -57 -104 -84 -141 -115 -345 -322 -486 -495 -47 -57
-114 -138 -148 -180 -35 -42 -66 -83 -70 -91 -3 -8 -43 -79 -88 -156 -200
-341 -350 -699 -428 -1019 -8 -33 -19 -76 -24 -95 -13 -45 -47 -244 -66 -385
-32 -229 -30 -717 4 -945 22 -151 43 -266 57 -325 8 -33 19 -80 24 -104 12
-58 38 -148 55 -188 8 -17 14 -38 14 -46 0 -8 12 -45 26 -83 14 -38 30 -82 36
-99 6 -16 19 -48 29 -71 11 -22 19 -45 19 -50 0 -29 233 -475 252 -482 4 -2 8
-10 8 -18 0 -8 17 -38 38 -67 21 -29 45 -63 52 -77 7 -14 45 -67 84 -119 39
-52 78 -104 87 -117 8 -13 29 -39 45 -57 16 -18 57 -64 90 -102 206 -234 447
-444 714 -623 47 -31 87 -59 90 -62 3 -4 21 -15 40 -26 19 -10 42 -24 50 -30
8 -6 40 -24 70 -40 30 -16 57 -31 60 -34 8 -9 252 -126 290 -140 19 -6 53 -20
75 -30 116 -52 136 -60 153 -60 10 0 22 -4 27 -8 6 -5 53 -21 105 -36 52 -15
108 -34 123 -42 16 -8 39 -14 51 -14 12 0 46 -7 76 -16 65 -19 195 -42 445
-79 17 -2 120 -9 230 -15 170 -10 291 -8 475 5 19 2 64 4 100 5 55 3 209 24
415 59 28 5 72 16 98 25 26 9 60 16 75 16 15 0 36 7 46 15 11 8 28 15 38 15
20 0 137 35 183 54 17 7 57 21 90 31 33 10 65 22 70 26 6 4 45 21 88 38 88 35
277 127 352 172 28 16 60 35 73 41 12 6 22 15 22 20 0 4 6 8 13 8 23 0 379
246 438 302 8 7 31 25 51 40 68 51 415 403 467 473 4 6 27 35 51 66 133 168
209 278 315 457 69 117 134 192 166 192 19 0 89 83 89 106 0 8 4 14 9 14 14 0
40 127 47 235 10 154 12 172 23 194 6 11 11 29 11 41 0 12 6 42 14 68 55 185
111 477 122 640 3 42 9 107 15 144 34 247 -21 860 -106 1163 -8 28 -21 82 -30
120 -9 39 -26 95 -37 125 -38 106 -60 165 -69 185 -4 11 -25 61 -44 110 -36
88 -137 297 -197 404 -36 66 -165 268 -178 281 -3 3 -13 16 -21 30 -69 107
-252 323 -409 481 -210 210 -359 332 -618 505 -163 109 -488 277 -642 334 -19
7 -48 18 -65 25 -79 34 -317 106 -470 144 -164 40 -409 77 -565 86 -58 3 -118
7 -135 9 -16 2 -43 1 -60 -1z m-168 -415 c17 -19 17 -20 -4 -38 -22 -18 -22
-18 -3 -40 11 -13 20 -38 20 -56 0 -27 -6 -36 -31 -49 -34 -18 -83 -13 -111
13 -23 19 -22 28 1 51 19 19 19 20 0 42 -10 12 -19 32 -19 44 0 58 103 81 147
33z m-340 7 c19 -13 21 -25 22 -94 0 -51 -4 -83 -12 -89 -15 -13 -118 -19
-134 -9 -14 9 -19 188 -6 200 13 13 109 7 130 -8z m170 -1 c4 -11 -2 -23 -18
-35 -21 -16 -22 -18 -6 -24 21 -9 23 -43 2 -51 -22 -9 -18 -32 6 -39 12 -4 19
-14 17 -23 -3 -13 -15 -17 -58 -17 l-55 0 -3 89 c-2 49 -1 95 2 103 8 20 105
18 113 -3z m350 0 c3 -8 -4 -25 -15 -37 -16 -17 -22 -38 -24 -87 -3 -65 -3
-65 -33 -65 l-30 0 -5 73 c-5 69 -11 83 -43 95 -5 1 -5 10 -2 20 10 24 142 25
152 1z m-584 -238 c14 -11 17 -25 15 -58 -3 -39 -6 -44 -36 -53 -23 -6 -34
-17 -38 -35 -10 -46 -13 -50 -43 -50 -20 0 -30 6 -34 19 -5 19 1 156 8 179 6
17 105 15 128 -2z m179 -3 c12 -14 16 -39 14 -103 l-1 -85 -75 0 -75 0 -3 89
c-2 49 -1 95 2 103 8 21 119 18 138 -4z m113 -88 l0 -100 -32 -3 -33 -3 0 99
c0 54 3 102 7 106 4 4 19 6 33 4 25 -3 25 -3 25 -103z m185 85 c21 -21 24 -37
14 -64 -8 -20 -48 -21 -67 -1 -18 17 -26 4 -19 -31 3 -19 7 -20 32 -11 52 20
81 -31 40 -68 -28 -25 -101 -26 -129 -1 -17 16 -21 31 -21 85 0 90 15 111 81
111 36 0 54 -5 69 -20z m155 9 c4 -5 0 -18 -9 -28 -20 -22 -20 -28 0 -48 14
-15 14 -18 -5 -37 l-21 -20 28 -22 c21 -17 24 -25 15 -35 -10 -10 -100 -15
-109 -6 -8 8 -11 164 -3 185 7 18 16 22 53 22 25 0 48 -5 51 -11z m-467 -335
c17 -11 22 -25 22 -57 1 -23 7 -53 14 -66 13 -23 14 -23 19 -5 4 10 9 33 12
49 14 84 19 90 64 93 49 4 71 -10 71 -44 0 -43 22 -126 31 -117 5 5 11 31 15
58 9 82 13 92 34 98 13 3 28 -2 40 -16 18 -19 21 -19 38 -4 22 20 36 21 49 5
11 -14 -6 -173 -21 -196 -11 -18 -41 -14 -61 8 -16 18 -20 19 -27 6 -6 -11
-24 -14 -74 -12 -36 2 -70 8 -76 14 -8 8 -17 7 -33 -4 -17 -11 -29 -12 -49 -4
-15 5 -32 7 -37 4 -6 -3 -50 -7 -99 -9 -49 -2 -94 -6 -99 -10 -6 -3 -19 -1
-30 4 -14 8 -27 6 -50 -5 -50 -25 -61 -8 -61 96 0 58 4 91 13 98 17 14 70 23
84 14 6 -4 24 -40 41 -81 33 -84 47 -81 37 8 -5 47 -3 61 10 74 21 22 93 22
123 1z m561 -20 c21 -5 31 -12 31 -25 0 -11 -4 -19 -9 -19 -20 0 -39 -31 -46
-77 -4 -26 -11 -56 -16 -65 -10 -19 -54 -25 -64 -9 -3 5 0 42 6 82 8 54 8 74
0 77 -6 2 -11 12 -11 23 0 15 7 19 39 19 21 0 53 -3 70 -6z m-915 -56 c27 -95
29 -123 12 -141 -25 -24 -85 -33 -115 -16 -29 17 -63 107 -59 159 3 33 5 35
40 35 20 0 40 3 44 8 4 4 20 7 35 7 26 0 30 -5 43 -52z m1089 25 c12 -7 8 -33
-6 -33 -27 0 -37 -21 -20 -46 14 -22 14 -24 -11 -35 -30 -14 -32 -25 -9 -51
15 -17 15 -21 3 -29 -14 -8 -84 -3 -102 8 -13 7 -8 46 15 113 31 92 32 93 81
85 22 -4 44 -9 49 -12z m-1305 -26 c6 -5 12 -19 12 -32 0 -12 9 -32 20 -45 18
-21 38 -86 28 -95 -12 -12 -98 -27 -122 -21 -48 12 -100 156 -69 187 25 25
102 29 131 6z m1455 -4 c16 -9 6 -34 -18 -43 -29 -11 -29 -13 -12 -41 8 -15 9
-23 1 -26 -6 -2 -20 -10 -30 -17 -18 -13 -18 -15 -2 -33 25 -28 9 -46 -35 -38
-20 4 -44 13 -54 20 -19 14 -17 26 30 143 l21 54 46 -7 c25 -4 48 -9 53 -12z
m-1913 -59 c25 -59 25 -58 -7 -73 -46 -22 -113 -40 -113 -31 0 5 8 11 18 15
20 6 42 45 42 73 0 16 26 62 35 62 2 0 13 -21 25 -46z m2268 33 c6 -7 14 -32
18 -55 4 -28 15 -49 32 -62 30 -24 18 -25 -45 -4 -72 24 -75 29 -53 72 11 20
20 42 20 49 0 17 15 17 28 0z m-2357 -202 c22 -7 142 -85 150 -97 3 -5 14 -45
25 -88 10 -44 23 -81 29 -84 6 -2 42 7 81 20 38 12 105 33 149 44 44 12 84 26
89 31 6 5 1 18 -13 32 l-22 24 38 7 c21 3 68 6 106 6 37 0 67 4 67 10 0 5 29
7 72 4 78 -5 120 2 97 17 -25 15 -3 19 47 9 133 -28 188 -32 339 -28 104 4
174 10 200 20 39 14 75 14 75 -1 0 -4 26 -8 58 -9 31 -1 68 -4 82 -7 14 -3 57
-9 97 -12 39 -3 77 -9 84 -14 22 -13 -30 -59 -115 -103 -42 -22 -76 -44 -76
-48 0 -5 3 -7 8 -5 61 33 188 87 206 87 26 0 139 -29 246 -64 47 -15 79 -20
86 -15 6 5 17 37 23 70 7 34 17 72 23 85 11 23 94 84 116 84 6 0 27 16 48 35
41 39 64 39 64 1 0 -17 -14 -36 -44 -60 -23 -20 -46 -36 -50 -36 -5 0 -21 -9
-37 -21 -35 -25 -64 -78 -74 -136 -7 -47 -15 -55 -67 -74 -34 -11 -46 -10
-145 21 -143 44 -195 44 -290 0 -40 -18 -73 -37 -73 -40 0 -4 33 -10 73 -13
103 -8 147 -23 189 -68 31 -33 37 -47 43 -102 11 -106 15 -102 -100 -102
l-100 0 -5 50 c-6 56 -15 75 -34 75 -37 0 -52 -89 -23 -133 8 -12 54 -49 103
-81 162 -109 184 -146 184 -315 0 -85 -3 -102 -23 -132 -48 -71 -145 -106
-267 -96 -97 8 -167 43 -195 98 -21 40 -37 172 -25 204 10 25 11 26 102 23
l93 -3 7 -79 c9 -101 33 -130 72 -90 27 27 15 174 -14 174 -3 0 -15 8 -26 18
-10 10 -45 34 -77 54 -133 83 -166 136 -167 266 0 86 13 132 50 179 11 14 18
28 16 30 -3 3 -44 -3 -93 -14 -110 -23 -421 -25 -525 -4 -37 7 -71 10 -77 6
-8 -4 -11 -135 -11 -411 0 -260 -4 -412 -10 -425 -9 -17 -22 -19 -103 -19 -51
0 -98 4 -105 8 -10 7 -12 101 -10 438 l3 429 25 3 c14 1 36 5 49 8 20 4 22 7
10 18 -8 7 -41 23 -74 36 -33 13 -66 28 -74 34 -25 20 -131 11 -216 -18 -113
-38 -153 -42 -192 -17 -23 15 -35 32 -43 63 -23 93 -38 114 -121 167 -73 48
-79 54 -79 86 0 41 20 50 40 19 8 -14 22 -27 31 -29z m-1310 -400 c4 -16 15
-79 24 -140 29 -194 37 -198 60 -29 9 60 19 129 23 154 l7 45 148 3 147 3 0
-436 0 -435 -23 -5 c-12 -3 -56 -5 -97 -3 l-75 3 -6 200 c-8 261 -8 259 -15
253 -6 -7 -16 -73 -44 -290 -10 -81 -21 -152 -25 -158 -7 -11 -104 -13 -121
-2 -13 8 -27 85 -49 262 -9 69 -18 136 -22 150 -13 58 -22 -21 -22 -206 -1
-152 -4 -194 -15 -203 -9 -8 -45 -11 -98 -9 l-83 3 -3 438 -2 438 142 -3 142
-3 7 -30z m1281 23 c3 -7 6 -47 7 -88 1 -41 5 -77 7 -79 3 -3 21 4 41 14 77
42 180 19 214 -47 19 -38 20 -55 17 -311 -3 -246 -5 -275 -22 -303 -38 -63
-135 -83 -206 -43 -36 20 -39 21 -61 5 -24 -16 -158 -23 -193 -10 -14 5 -16
53 -16 433 0 235 3 431 7 434 13 13 201 8 205 -5z m586 -37 c2 -28 -1 -47 -10
-52 -21 -14 -192 -11 -206 3 -13 13 -16 56 -6 83 5 13 22 15 113 13 l106 -3 3
-44z m2346 33 c3 -9 6 -49 6 -90 0 -41 4 -74 9 -74 5 0 28 9 52 20 55 24 93
25 145 1 70 -32 74 -49 74 -353 0 -231 -2 -267 -18 -297 -39 -78 -122 -100
-207 -57 -47 24 -51 25 -63 9 -9 -13 -30 -18 -87 -20 -42 -1 -87 2 -100 7
l-25 10 0 423 c0 233 3 427 7 430 3 4 50 7 104 7 79 0 98 -3 103 -16z m-3346
-156 c65 -32 100 -81 112 -154 13 -76 13 -316 0 -382 -23 -124 -102 -182 -246
-182 -128 0 -192 31 -225 107 -17 39 -19 70 -19 258 0 172 3 220 16 251 27 65
75 106 149 125 52 14 163 2 213 -23z m1721 16 c36 -10 66 -29 96 -58 52 -52
67 -111 63 -232 l-3 -79 -135 -5 -135 -5 -3 -90 c-4 -114 1 -135 32 -135 28 0
36 21 36 101 0 36 5 61 14 68 9 8 46 11 103 9 l88 -3 0 -80 c0 -72 -3 -85 -30
-128 -38 -60 -93 -88 -185 -95 -133 -9 -228 39 -264 132 -25 66 -20 444 6 493
58 104 183 147 317 107z m-721 -358 c2 -273 -1 -351 -10 -358 -21 -13 -192
-10 -206 4 -9 9 -12 99 -12 344 0 183 3 340 6 349 5 13 22 15 113 13 l106 -3
3 -349z m1754 352 c1 -2 5 -136 8 -298 l5 -295 23 -3 c12 -2 23 -2 24 0 1 2 5
136 8 298 l5 295 105 0 105 0 3 -344 c1 -224 -1 -348 -8 -355 -13 -13 -201
-10 -210 4 -4 7 -23 3 -55 -11 -91 -40 -190 -8 -213 69 -13 42 -18 623 -5 635
6 6 200 10 205 5z m498 -848 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10
10 10 6 0 10 -4 10 -10z m-1260 -41 c0 -11 -21 -11 -39 0 -9 6 -5 9 13 9 14 0
26 -4 26 -9z m2987 -41 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z
m-2127 3 c0 -6 -4 -13 -10 -16 -5 -3 -10 1 -10 9 0 9 5 16 10 16 6 0 10 -4 10
-9z m1850 -1 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4
11 -10z m87 -12 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m230
-190 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -145 c-2 -21 -4
-4 -4 37 0 41 2 58 4 38 2 -21 2 -55 0 -75z m-3000 -30 c-3 -10 -5 -4 -5 12 0
17 2 24 5 18 2 -7 2 -21 0 -30z m-2840 -426 c18 -9 44 -33 59 -52 22 -30 26
-45 28 -107 l1 -73 -95 0 -95 0 -6 48 c-5 46 -19 67 -46 67 -17 0 -36 -39 -35
-73 1 -37 20 -57 116 -125 102 -72 153 -124 166 -170 5 -20 10 -79 10 -131 0
-121 -19 -159 -99 -199 -48 -23 -69 -27 -141 -27 -97 0 -160 23 -203 75 -30
36 -50 116 -45 185 l3 50 89 3 c49 2 93 -1 99 -7 5 -5 10 -31 12 -58 1 -26 3
-58 3 -70 2 -26 34 -38 62 -23 16 9 20 21 20 63 0 29 -6 61 -14 72 -7 11 -61
54 -119 95 -140 100 -160 132 -161 255 -1 105 15 147 68 183 52 35 82 42 191
39 71 -2 109 -8 132 -20z m2438 -1 c57 -26 78 -47 99 -96 17 -41 31 -188 22
-225 l-7 -26 -102 3 -102 3 -5 100 c-5 108 -11 125 -40 125 -40 0 -44 -31 -41
-300 2 -250 6 -280 36 -280 27 0 40 35 45 119 l5 86 96 3 c125 4 125 3 111
-124 -14 -120 -38 -161 -121 -201 -71 -35 -178 -39 -255 -9 -66 25 -84 42
-112 101 -23 49 -24 57 -24 318 0 244 2 271 19 305 20 38 47 67 91 94 37 22
54 26 150 27 70 1 94 -3 135 -23z m997 7 c55 -22 85 -49 97 -87 13 -39 17
-128 7 -144 -8 -13 -151 -17 -180 -6 -11 4 -16 19 -16 48 0 61 -30 84 -64 50
-19 -18 -20 -53 -4 -89 6 -14 48 -51 92 -82 166 -114 197 -164 195 -312 -1
-99 -16 -139 -67 -178 -109 -83 -324 -59 -392 44 -21 33 -24 50 -25 128 l0 90
89 3 c103 3 106 2 106 -76 0 -62 13 -92 40 -92 30 0 50 28 50 70 0 63 -18 86
-119 158 -126 89 -157 122 -171 184 -18 72 -8 177 20 223 36 58 103 85 212 85
59 0 101 -6 130 -17z m-2914 -10 c11 -21 10 -128 0 -139 -4 -4 -36 -10 -70
-13 l-63 -6 -3 -49 c-6 -85 1 -96 57 -96 79 0 81 -2 81 -86 0 -83 2 -81 -90
-86 l-45 -3 0 -85 0 -85 70 -3 c38 -2 75 -8 82 -14 14 -12 18 -125 5 -146 -7
-9 -52 -12 -193 -10 l-184 3 -3 395 c-1 217 0 405 3 418 5 22 7 22 175 22 151
0 170 -2 178 -17z m441 8 c48 -10 84 -33 115 -74 16 -22 21 -47 24 -121 5
-114 -8 -160 -49 -182 l-30 -15 41 -40 40 -39 -2 -178 -3 -177 -95 0 -95 0 -5
173 c-5 158 -7 175 -25 188 -10 8 -24 13 -30 11 -6 -2 -12 -74 -15 -188 l-5
-184 -105 0 -105 0 -3 395 c-1 217 0 405 3 418 5 22 8 22 153 22 81 -1 167 -5
191 -9z m400 -4 c6 -8 15 -63 20 -123 22 -238 33 -329 42 -338 14 -15 17 7 34
224 8 113 18 215 20 228 5 22 8 23 113 20 l107 -3 -1 -40 c0 -40 -45 -389 -64
-495 -5 -30 -15 -100 -21 -155 -19 -159 -2 -145 -183 -145 -172 0 -159 -6
-170 75 -6 42 -34 224 -86 544 -17 106 -29 200 -26 207 7 20 199 20 215 1z
m585 -3 c8 -21 8 -753 0 -793 l-7 -32 -101 3 -101 3 -3 405 c-1 223 0 411 3
417 3 9 33 13 104 13 81 0 100 -3 105 -16z m1044 4 c16 -16 16 -134 0 -145 -7
-4 -40 -10 -73 -13 l-60 -5 0 -70 0 -70 60 -5 60 -5 3 -77 3 -77 -33 -5 c-18
-3 -46 -7 -63 -8 l-30 -3 -3 -79 c-2 -44 1 -83 7 -89 5 -5 33 -9 62 -9 83 1
90 -6 87 -91 l-3 -72 -185 0 -185 0 -3 405 c-1 223 0 411 3 417 6 18 336 18
353 1z m328 -1254 c32 -15 34 -19 34 -69 0 -65 -13 -77 -77 -73 -45 3 -48 5
-48 30 -1 39 -18 54 -39 33 -33 -33 -20 -66 49 -130 58 -54 65 -65 65 -99 0
-49 -26 -135 -48 -161 -58 -69 -220 -75 -264 -11 -11 16 -10 90 2 120 9 24 15
26 66 26 l57 0 -6 -44 c-5 -31 -2 -47 7 -55 23 -19 46 14 46 64 0 36 -5 46
-32 68 -71 53 -88 77 -88 122 0 50 25 127 48 148 53 48 161 63 228 31z m-1211
-44 l-7 -50 54 6 c66 8 98 -6 98 -42 0 -27 -61 -282 -79 -326 -21 -54 -103
-84 -147 -54 -13 10 -25 11 -35 5 -15 -9 -112 -13 -121 -4 -3 4 23 119 58 258
35 139 64 253 64 255 0 1 27 2 61 2 l61 0 -7 -50z m365 26 c0 -28 -16 -36 -75
-36 -48 0 -60 10 -50 40 5 17 15 20 66 20 56 0 59 -1 59 -24z m190 4 c0 -20
-34 -173 -50 -225 -5 -16 -19 -70 -31 -120 -39 -166 -32 -155 -100 -155 -65 0
-67 3 -49 69 5 20 30 121 55 225 25 104 50 197 56 207 8 15 21 19 64 19 48 0
55 -3 55 -20z m1244 -29 l-6 -49 59 5 c65 6 93 -9 93 -50 0 -39 -76 -314 -94
-341 -21 -33 -62 -50 -101 -41 -16 4 -63 6 -102 5 -40 -1 -77 1 -81 4 -8 4 58
292 107 474 l12 42 60 0 60 0 -7 -49z m-4226 -49 c9 -6 10 -27 4 -85 -6 -58
-5 -77 4 -77 6 0 14 8 17 18 19 62 51 138 60 144 14 9 60 10 80 2 13 -4 14
-19 10 -81 -7 -84 3 -90 31 -21 10 24 24 58 32 75 l13 33 108 -3 108 -2 0 -45
c0 -25 -4 -66 -8 -92 -13 -74 6 -58 43 37 18 47 39 90 46 96 7 5 30 9 51 7
l38 -3 -3 -85 c-3 -80 -2 -83 12 -60 9 14 25 50 36 80 12 30 27 58 33 62 7 4
56 8 111 8 l99 0 -7 -97 c-6 -86 -5 -96 7 -78 8 11 20 38 27 60 7 22 21 57 32
78 18 36 21 38 61 35 l42 -3 -3 -77 c-1 -43 1 -78 6 -78 5 0 19 26 32 58 38
91 47 102 91 102 21 0 41 -4 44 -10 5 -8 -15 -69 -110 -325 -12 -33 -26 -68
-30 -78 -6 -15 -18 -17 -74 -15 l-66 3 3 68 c4 71 -8 88 -27 37 -6 -16 -16
-45 -23 -62 -6 -18 -17 -36 -22 -40 -15 -11 -124 -10 -130 1 -3 5 1 62 9 127
17 135 19 223 6 208 -5 -5 -35 -79 -66 -164 -32 -85 -63 -161 -68 -167 -6 -8
-34 -13 -75 -13 l-65 0 7 72 c7 64 6 70 -8 59 -8 -7 -23 -34 -32 -59 -26 -71
-30 -73 -98 -70 l-61 3 1 50 c0 46 17 210 30 298 11 67 -12 40 -51 -60 -20
-54 -45 -118 -55 -143 -10 -25 -25 -69 -35 -97 l-17 -53 -70 0 -70 0 4 59 c1
33 0 63 -4 67 -4 4 -21 -23 -38 -59 l-30 -67 -65 0 -65 0 0 33 c0 30 22 229
36 327 4 25 11 51 17 58 11 13 65 16 85 4z m1562 -2 c8 0 34 3 58 6 31 4 49 2
68 -11 24 -15 28 -15 59 -1 38 18 78 20 106 6 28 -15 25 -59 -16 -218 -57
-220 -48 -202 -111 -202 -67 0 -66 -7 -18 184 35 137 38 176 15 176 -17 0 -29
-33 -62 -162 -17 -67 -35 -140 -40 -160 l-10 -38 -54 0 c-30 0 -56 4 -59 8 -3
5 9 62 25 128 48 187 50 197 45 211 -3 7 -12 13 -20 13 -17 0 -29 -37 -66
-190 -12 -52 -28 -111 -35 -130 -12 -34 -15 -35 -70 -38 l-57 -3 5 33 c8 52
88 361 99 381 8 16 18 18 66 13 31 -3 64 -6 72 -6z m613 -10 c38 -30 40 -63
12 -177 -33 -139 -55 -182 -109 -215 -55 -36 -149 -40 -188 -8 -38 29 -39 63
-8 194 44 181 84 225 206 226 47 0 67 -5 87 -20z m591 11 c3 -5 -10 -73 -29
-152 -20 -79 -41 -166 -47 -194 -17 -72 -22 -76 -87 -73 -53 3 -56 4 -53 28 9
68 94 385 105 392 17 11 105 10 111 -1z m498 -22 c29 -28 30 -33 24 -84 -3
-30 -10 -65 -16 -79 -9 -25 -13 -26 -83 -26 -43 0 -80 -5 -90 -12 -10 -8 -18
-36 -23 -77 -6 -58 -5 -63 12 -59 13 2 25 20 36 53 l16 50 51 3 c63 4 70 -9
43 -71 -30 -68 -80 -101 -161 -105 -55 -3 -70 -1 -93 17 -38 31 -42 67 -19
176 24 110 50 171 89 208 32 30 48 34 125 36 53 1 62 -2 89 -30z m585 20 c7
-7 3 -39 -14 -107 -55 -224 -57 -242 -32 -242 15 0 34 52 70 200 18 74 37 141
42 148 13 17 106 16 113 -1 4 -12 -35 -184 -87 -380 l-10 -38 -77 1 c-42 1
-98 -2 -123 -6 -55 -8 -79 11 -79 60 0 42 76 344 91 362 14 17 90 19 106 3z
m940 -13 c21 -18 28 -33 27 -62 0 -67 -6 -74 -70 -74 l-57 0 7 39 c7 44 -9 65
-29 38 -15 -21 -68 -241 -63 -264 6 -31 30 -19 47 22 25 61 29 65 77 65 42 0
44 -1 44 -29 0 -37 -53 -108 -100 -132 -40 -22 -113 -25 -150 -6 -47 23 -55
60 -35 150 49 229 85 275 217 276 46 1 62 -4 85 -23z m332 9 c48 -25 53 -66
20 -196 -46 -186 -82 -224 -209 -224 -119 0 -135 29 -100 185 33 151 72 217
140 243 30 11 122 7 149 -8z m271 4 c8 0 34 3 56 6 31 6 49 3 71 -10 27 -16
32 -16 61 -1 36 18 75 21 103 6 26 -14 25 -59 -5 -178 -14 -53 -27 -111 -30
-129 -4 -17 -12 -49 -19 -70 -12 -38 -13 -38 -70 -41 -68 -4 -67 -7 -32 128
43 160 50 209 36 223 -19 19 -38 -14 -56 -102 -9 -42 -23 -96 -30 -121 -8 -25
-19 -64 -25 -87 l-11 -43 -54 0 c-30 0 -56 3 -58 8 -3 4 14 80 36 169 34 130
40 164 29 175 -22 22 -39 -12 -72 -147 -17 -71 -36 -147 -41 -167 l-10 -38
-54 0 c-30 0 -57 5 -60 10 -4 6 2 41 13 78 11 37 26 94 32 127 19 93 52 199
64 208 6 4 34 5 61 2 28 -2 57 -5 65 -6z m766 -6 c19 -20 18 -41 -12 -157 -14
-56 -32 -130 -41 -166 -9 -36 -21 -71 -26 -77 -5 -8 -32 -13 -63 -13 -45 0
-54 3 -54 18 0 9 18 87 39 172 22 85 37 158 35 162 -11 17 -32 7 -43 -19 -6
-16 -18 -57 -26 -93 -8 -36 -25 -103 -37 -150 l-23 -85 -60 0 c-67 0 -66 -1
-47 80 48 200 85 330 94 336 6 4 65 7 130 6 89 0 123 -4 134 -14z m244 7 c8 0
39 3 68 6 l54 6 -5 -58 c-7 -87 -75 -350 -100 -388 -47 -71 -244 -88 -278 -25
-5 11 -7 29 -4 39 5 17 15 20 60 20 30 0 57 -4 60 -10 11 -18 45 -11 54 13 13
31 -1 40 -44 28 -45 -12 -89 6 -98 39 -12 48 51 274 88 314 24 26 30 27 78 22
29 -3 59 -6 67 -6z m-5103 -336 c3 -8 1 -29 -4 -47 -8 -30 -12 -32 -53 -32
-44 0 -45 1 -41 30 5 50 18 65 57 65 22 0 37 -6 41 -16z m3136 3 c2 -7 -1 -28
-7 -47 -10 -32 -15 -35 -53 -38 -48 -4 -53 7 -32 67 10 27 15 31 49 31 21 0
40 -6 43 -13z m1318 1 c2 -17 0 -38 -7 -66 -4 -20 -10 -23 -47 -20 -41 3 -42
4 -39 37 1 19 7 41 14 48 14 17 78 17 79 1z m-1791 -330 c0 -5 -11 -26 -25
-46 -14 -20 -25 -47 -25 -60 0 -14 9 -26 25 -34 14 -6 25 -15 25 -19 0 -14
-196 -118 -280 -149 -46 -17 -86 -33 -88 -35 -2 -1 8 -25 21 -52 37 -74 41
-104 17 -131 -11 -12 -26 -22 -33 -22 -22 0 -44 53 -51 120 -3 36 -13 85 -21
109 -9 24 -13 51 -10 60 8 22 195 161 217 161 5 0 14 -13 19 -30 7 -19 18 -30
30 -30 23 0 62 59 53 80 -14 35 -7 46 45 71 52 26 81 28 81 7z m121 -352 c6
-13 20 -27 30 -29 50 -13 26 -59 -125 -232 -111 -127 -102 -112 -84 -143 9
-15 19 -59 23 -98 7 -71 6 -72 -29 -120 -20 -27 -48 -71 -63 -97 -49 -85 -209
-290 -334 -426 -57 -64 -69 -72 -69 -53 0 13 14 56 31 95 17 39 36 100 41 137
6 36 12 75 14 87 2 12 20 31 40 43 19 13 40 34 46 49 6 14 10 89 10 166 0 114
-4 154 -22 215 -33 117 -34 132 -8 151 13 9 61 33 107 53 46 20 98 48 114 62
16 14 51 36 76 49 25 13 55 32 66 42 31 30 98 73 113 73 7 0 17 -11 23 -24z
m-561 -381 c0 -7 4 -15 9 -17 5 -1 11 -21 13 -43 2 -22 8 -47 13 -55 10 -15
10 -228 1 -237 -14 -15 -26 15 -26 65 0 31 -7 88 -15 127 -13 62 -13 71 2 87
9 10 13 24 9 35 -7 17 -8 17 -17 1 -12 -22 -59 -24 -59 -3 0 17 50 66 62 59 4
-3 8 -11 8 -19z m-626 -42 c5 -17 3 -29 -6 -34 -28 -18 -42 -3 -32 36 8 33 30
32 38 -2z m216 -36 c0 -17 -29 -57 -41 -57 -12 0 -11 12 1 44 10 27 40 36 40
13z m114 -22 c20 -19 36 -40 36 -48 0 -7 7 -23 16 -35 30 -43 -7 -22 -62 34
-54 57 -59 65 -47 77 11 12 21 8 57 -28z m-416 -182 c7 -12 12 -51 12 -86 l0
-65 58 -28 57 -29 -3 -71 c-4 -78 12 -205 34 -267 14 -40 14 -42 -8 -59 -13
-9 -43 -24 -67 -32 -38 -12 -46 -12 -71 2 -40 23 -84 7 -88 -31 -2 -18 2 -29
12 -33 26 -10 19 -26 -30 -74 -25 -25 -61 -60 -79 -77 -29 -29 -55 -42 -55
-29 0 2 9 26 20 52 24 56 21 73 -13 67 -21 -4 -28 2 -47 41 -12 25 -25 46 -30
46 -4 0 -10 18 -14 39 -5 32 -11 41 -36 50 -54 18 -52 50 5 146 28 46 35 67
31 90 -23 131 -23 135 -1 183 39 85 111 178 220 287 l70 70 5 -85 c3 -47 11
-95 18 -107z m678 81 c4 -17 2 -29 -7 -34 -10 -7 -10 -11 0 -24 7 -8 10 -20 7
-25 -4 -5 -2 -12 4 -16 16 -10 12 -51 -7 -66 -11 -10 -14 -10 -9 -1 4 6 3 12
-3 12 -5 0 -17 7 -26 16 -15 15 -15 18 1 35 12 13 13 19 4 19 -7 0 -10 7 -6
15 3 9 -1 18 -9 21 -30 12 -8 74 25 74 13 0 22 -9 26 -26z m-98 -42 c4 -38
-14 -43 -28 -6 -14 36 -12 46 8 42 11 -2 18 -14 20 -36z m-73 -14 c8 -13 21
-23 28 -24 6 0 22 -2 35 -2 23 -2 31 -27 10 -35 -10 -4 -10 -8 1 -15 8 -6 11
-17 8 -26 -3 -8 -2 -18 3 -21 14 -8 12 -62 -1 -71 -23 -14 -212 -20 -277 -9
-26 5 -32 10 -28 22 4 9 9 39 12 67 9 89 19 103 76 111 59 8 71 0 39 -26 -23
-19 -23 -20 -5 -40 20 -22 29 -89 12 -89 -7 0 -6 -6 2 -15 22 -26 38 -17 38
20 0 19 -4 38 -9 41 -6 3 -5 11 2 20 7 9 9 29 6 51 -10 57 19 82 48 41z m-235
-79 c0 -10 -5 -19 -11 -19 -8 0 -8 -4 0 -14 15 -18 4 -85 -14 -92 -7 -3 -28
-1 -46 3 -27 7 -35 15 -37 37 -2 15 2 34 9 42 8 10 8 14 0 14 -22 0 -12 39 12
44 72 16 87 13 87 -15z m-182 9 c-2 -4 7 -14 19 -23 14 -10 19 -22 16 -35 -6
-22 -20 -25 -43 -10 -20 12 -23 82 -3 78 8 -2 13 -6 11 -10z m360 -275 c3 -69
2 -73 -25 -90 -34 -21 -43 -33 -43 -55 0 -22 16 -23 37 -3 8 8 19 13 24 10 12
-8 11 -225 -1 -262 -14 -39 -59 -62 -76 -38 -19 25 -27 172 -21 344 6 169 8
173 67 169 l35 -3 3 -72z m-73 -524 c0 -10 -16 -15 -54 -17 -65 -4 -92 14 -35
23 22 3 46 8 54 9 24 5 35 0 35 -15z m235 7 c0 -8 -5 -18 -12 -22 -16 -10 -90
-5 -105 8 -6 5 -19 8 -29 6 -9 -2 -19 2 -21 7 -2 7 28 12 82 13 69 2 85 0 85
-12z"
          />
          <path d="M5345 7750 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z" />
          <path
            d="M4746 7707 c-24 -18 -18 -61 9 -65 43 -5 64 40 29 64 -17 12 -23 12
-38 1z"
          />
          <path
            d="M5326 7694 c-10 -27 12 -56 42 -52 30 3 41 30 22 53 -16 20 -56 19
-64 -1z"
          />
          <path
            d="M5027 7663 c-13 -13 -7 -50 11 -66 24 -22 25 -21 55 5 21 18 23 26
14 45 -7 17 -19 23 -42 23 -17 0 -35 -3 -38 -7z"
          />
          <path
            d="M3847 7193 c-9 -8 -9 -436 -1 -457 3 -9 14 -16 24 -16 10 0 21 7 24
16 3 9 6 109 6 224 0 115 -3 215 -6 224 -6 16 -35 22 -47 9z"
          />
          <path
            d="M6777 7194 c-9 -9 -9 -436 -1 -458 9 -24 43 -20 49 7 3 12 4 119 3
237 -3 208 -4 215 -23 218 -12 2 -24 0 -28 -4z"
          />
          <path
            d="M3256 7178 c-10 -40 -7 -418 4 -439 13 -23 46 -25 54 -3 3 9 6 109 6
224 0 115 -3 215 -6 224 -10 25 -51 20 -58 -6z"
          />
          <path
            d="M5026 7185 c-3 -9 -6 -38 -6 -65 0 -41 3 -50 21 -55 32 -10 40 6 37
71 -3 51 -6 59 -24 62 -13 2 -24 -4 -28 -13z"
          />
          <path
            d="M3434 5437 c-3 -8 -4 -47 -2 -88 2 -59 6 -74 19 -77 9 -2 24 4 33 13
22 22 22 127 0 149 -19 20 -43 21 -50 3z"
          />
          <path
            d="M4674 4158 c-10 -34 -44 -167 -54 -213 -5 -25 -4 -45 2 -53 17 -20
34 2 48 65 7 32 21 91 32 131 10 39 16 77 13 82 -11 18 -33 11 -41 -12z"
          />
          <path
            d="M6467 4133 c-28 -89 -59 -232 -53 -242 10 -15 33 -2 40 22 27 93 56
216 56 239 0 46 -27 33 -43 -19z"
          />
          <path
            d="M4334 4172 c-12 -7 -74 -229 -74 -263 0 -12 7 -19 19 -19 15 0 24 21
50 125 39 157 40 180 5 157z"
          />
          <path
            d="M5410 4161 c-17 -32 -12 -61 9 -61 13 0 21 9 26 30 10 47 -14 69 -35
31z"
          />
          <path
            d="M7285 4169 c-11 -17 -65 -230 -65 -255 0 -58 42 -22 54 46 4 19 16
70 28 112 20 74 20 108 -1 108 -5 0 -13 -5 -16 -11z"
          />
          <path
            d="M8632 4167 c-17 -20 -56 -193 -48 -213 6 -15 9 -16 20 -3 18 18 66
196 59 215 -6 17 -17 18 -31 1z"
          />
          <path
            d="M6004 2829 c-10 -17 11 -31 42 -27 18 2 30 10 32 21 3 13 -4 17 -32
17 -19 0 -38 -5 -42 -11z"
          />
          <path
            d="M6038 2605 c-9 -21 -9 -29 4 -42 22 -22 38 -8 38 33 0 41 -25 47 -42
9z"
          />
          <path
            d="M5063 2364 c-3 -8 -1 -20 5 -26 15 -15 43 -2 36 16 -8 21 -34 28 -41
10z"
          />
          <path
            d="M2399 9092 c-129 -82 -146 -247 -36 -352 56 -55 122 -76 187 -60 27
6 62 23 77 36 15 13 31 24 34 24 13 0 60 70 65 99 5 26 2 32 -20 42 -26 12
-30 10 -84 -49 -54 -58 -60 -62 -102 -62 -25 0 -56 6 -70 13 -40 20 -70 74
-70 126 0 63 27 92 129 141 26 12 36 37 22 54 -21 25 -81 20 -132 -12z"
          />
          <path
            d="M4960 9042 c-18 -15 -20 -22 -11 -42 5 -14 12 -41 16 -61 5 -32 9
-36 28 -32 37 10 49 23 35 40 -7 8 -11 33 -9 55 2 26 -2 44 -11 49 -18 12 -23
11 -48 -9z"
          />
          <path
            d="M5120 9050 c-19 -4 -26 -14 -32 -45 -7 -44 -2 -76 16 -87 17 -12 61
-9 74 4 9 9 16 7 31 -7 15 -12 29 -16 51 -11 22 4 32 2 37 -9 3 -9 12 -13 22
-10 9 3 36 -4 59 -15 22 -11 46 -20 52 -20 5 0 18 -4 28 -10 9 -5 37 -18 62
-29 25 -12 59 -30 75 -40 41 -27 56 -26 103 9 49 35 52 36 46 13 -3 -10 -21
-28 -40 -41 -18 -12 -34 -27 -34 -32 0 -23 32 -21 64 4 19 14 44 26 55 26 31
0 27 36 -6 57 -16 10 -43 32 -61 50 -29 27 -38 30 -59 22 -13 -5 -25 -9 -27
-9 -1 0 -2 12 -1 28 0 22 -5 28 -27 30 -15 2 -36 -2 -48 -8 -17 -9 -20 -8 -20
13 0 41 -68 62 -92 29 -24 -33 -33 -31 -33 6 0 32 -3 37 -26 40 -19 2 -33 -4
-47 -22 -26 -34 -33 -33 -30 6 3 29 0 32 -35 41 -46 11 -60 1 -75 -53 -11 -37
-11 -37 -15 39 -2 27 -30 41 -67 31z"
          />
          <path
            d="M4843 9034 c-7 -3 -13 -22 -14 -42 l0 -37 -16 33 c-10 19 -24 32 -36
32 -17 0 -19 -5 -13 -42 6 -36 5 -40 -9 -28 -8 7 -15 19 -15 26 0 19 -47 29
-76 15 -30 -13 -30 -24 -2 -83 25 -53 44 -59 94 -33 16 8 39 15 51 15 12 0 25
5 28 11 4 6 19 7 36 4 51 -11 107 42 63 59 -9 3 -24 6 -35 6 -10 0 -19 4 -19
10 0 5 10 9 23 7 17 -2 22 3 22 23 0 22 -5 25 -35 27 -19 1 -41 0 -47 -3z"
          />
          <path
            d="M8187 8998 c-14 -13 -62 -68 -108 -123 -46 -55 -86 -102 -90 -105 -9
-8 -29 -48 -29 -59 0 -18 48 -43 63 -34 8 4 44 43 81 86 37 42 72 77 77 77 5
0 9 -38 9 -85 0 -83 1 -85 26 -91 14 -4 43 -2 64 5 41 12 90 15 90 4 0 -7 -46
-70 -67 -91 -59 -61 -76 -108 -48 -132 27 -22 59 -1 133 89 40 48 80 97 90
107 67 74 75 101 40 134 -25 23 -50 23 -157 0 -83 -18 -85 -16 -76 95 7 92 6
95 -19 120 -31 31 -48 31 -79 3z"
          />
          <path
            d="M4562 8950 c-37 -16 -37 -37 3 -85 40 -49 74 -60 76 -22 0 12 3 34 5
49 3 19 -2 34 -16 48 -22 22 -33 23 -68 10z"
          />
          <path
            d="M4420 8870 c-14 -17 -35 -33 -48 -37 -24 -6 -43 -39 -35 -60 3 -7 20
-17 39 -23 34 -12 44 -32 22 -46 -6 -4 -16 0 -23 9 -7 10 -17 17 -23 17 -6 0
-17 7 -26 15 -17 18 -46 10 -46 -13 0 -8 8 -24 18 -35 17 -20 16 -20 -17 -13
-25 4 -39 2 -53 -10 -30 -28 -22 -49 30 -73 58 -27 92 -25 108 8 12 23 29 43
92 106 29 28 32 36 23 54 -7 13 -22 21 -36 21 -18 0 -25 5 -25 20 0 27 8 25
63 -11 26 -17 51 -28 57 -24 16 10 12 33 -10 55 -12 12 -25 32 -30 45 -13 35
-49 32 -80 -5z"
          />
          <path
            d="M2075 8801 c-116 -54 -161 -191 -84 -255 46 -39 98 -35 173 10 37 23
72 37 95 38 33 1 36 -1 39 -30 2 -25 -4 -37 -38 -67 -24 -22 -50 -37 -66 -37
-41 0 -64 -18 -64 -49 0 -66 115 -52 193 23 51 50 72 101 64 158 -6 46 -29 75
-76 95 -44 19 -83 10 -158 -39 -71 -45 -106 -48 -111 -8 -3 30 42 79 90 95 40
13 57 39 42 63 -15 24 -52 25 -99 3z"
          />
          <path
            d="M5763 8708 c-24 -16 -43 -34 -43 -39 0 -5 12 -27 26 -49 26 -38 56
-51 69 -30 3 6 17 10 30 10 13 0 27 5 30 10 3 6 15 10 26 10 23 0 25 23 3 44
-18 19 -28 20 -55 6 -15 -9 -19 -7 -19 6 0 10 5 14 15 10 21 -8 31 20 15 39
-18 22 -50 17 -97 -17z"
          />
          <path
            d="M8475 8509 c-110 -98 -135 -126 -135 -147 0 -20 24 -52 91 -124 50
-54 97 -98 105 -98 7 0 21 11 30 25 19 30 14 41 -61 125 -51 57 -54 69 -24 96
20 18 21 18 86 -49 70 -72 103 -84 123 -46 13 24 11 27 -64 114 -52 59 -54 74
-12 99 14 9 28 -1 85 -61 69 -74 97 -87 121 -58 19 23 5 55 -55 120 -31 33
-67 75 -82 93 -41 52 -58 45 -208 -89z"
          />
          <path
            d="M1805 8497 c-38 -18 -175 -171 -175 -196 0 -11 25 -41 56 -67 31 -27
69 -60 84 -74 15 -14 45 -41 66 -61 65 -59 86 -70 110 -56 12 7 53 49 92 94
51 59 72 91 76 120 13 72 -26 128 -96 140 -31 4 -41 12 -52 37 -7 17 -23 39
-34 49 -27 24 -89 31 -127 14z m69 -90 c22 -16 11 -48 -37 -102 -34 -39 -35
-39 -61 -22 -36 24 -33 43 18 93 47 48 54 50 80 31z m144 -132 c2 -24 -6 -39
-39 -72 -45 -47 -63 -52 -91 -26 -26 24 -23 35 27 87 36 38 51 47 72 44 23 -2
29 -9 31 -33z"
          />
          <path
            d="M4138 8330 l-23 -19 22 -22 c20 -20 24 -21 53 -9 22 9 30 18 28 33
-4 31 -52 40 -80 17z"
          />
          <path
            d="M5940 8343 c-37 -14 -39 -50 -4 -63 50 -19 91 35 45 60 -11 5 -21 10
-23 9 -2 0 -10 -3 -18 -6z"
          />
          <path
            d="M8862 8338 c-18 -18 -15 -52 8 -81 29 -37 25 -62 -13 -86 -18 -11
-42 -28 -54 -39 -12 -10 -49 -38 -82 -62 -61 -45 -82 -80 -60 -106 22 -26 60
-16 119 33 53 44 165 123 175 123 7 0 26 -16 44 -35 34 -37 61 -44 81 -20 15
18 7 53 -17 80 -10 11 -38 47 -62 80 -57 77 -102 125 -116 125 -6 0 -16 -5
-23 -12z"
          />
          <path
            d="M1525 8186 c-13 -19 -14 -29 -5 -45 6 -12 14 -21 18 -21 5 0 17 -8
28 -18 10 -9 42 -32 69 -49 78 -49 107 -85 107 -128 0 -54 -38 -90 -95 -89
-35 1 -58 12 -136 67 -52 37 -105 67 -117 67 -26 0 -48 -32 -40 -58 6 -18 118
-100 199 -144 89 -50 170 -33 242 50 50 56 51 160 4 221 -27 35 -222 171 -244
171 -8 0 -22 -11 -30 -24z"
          />
          <path
            d="M9111 8023 c-14 -6 -203 -129 -273 -178 -22 -15 -38 -35 -38 -46 0
-24 136 -235 156 -243 21 -8 50 9 57 33 3 12 -8 40 -29 73 -63 100 -66 106
-54 129 20 37 51 19 102 -58 42 -63 52 -73 78 -73 46 0 50 37 11 97 -17 27
-39 63 -48 81 -16 30 -16 34 -1 48 25 26 60 10 87 -38 61 -108 103 -135 131
-84 11 22 10 30 -15 73 -38 64 -115 176 -129 185 -12 9 -15 9 -35 1z"
          />
          <path
            d="M1269 7770 c-68 -36 -123 -153 -105 -224 8 -34 54 -75 91 -82 48 -9
85 12 151 81 33 36 67 65 75 65 27 0 42 -18 42 -48 0 -39 -25 -78 -66 -102
-48 -28 -57 -39 -57 -64 0 -36 20 -47 63 -35 78 21 157 128 157 212 0 53 -44
112 -95 126 -57 15 -95 -2 -164 -75 -46 -48 -68 -64 -84 -62 -19 3 -22 9 -21
42 1 33 9 46 48 81 46 43 56 71 34 93 -16 16 -26 15 -69 -8z"
          />
          <path
            d="M9283 7662 c-17 -9 -79 -42 -137 -71 -138 -72 -161 -90 -153 -123 9
-35 30 -41 80 -23 23 8 50 15 59 15 30 0 32 -44 4 -121 -14 -40 -26 -80 -26
-89 0 -19 36 -70 49 -70 5 0 20 29 36 65 15 36 31 67 34 70 4 2 25 -2 47 -10
41 -14 88 -9 130 13 36 19 55 59 55 117 1 46 -6 69 -42 138 -23 45 -48 88 -55
95 -17 16 -42 15 -81 -6z m72 -164 c23 -45 28 -62 19 -75 -33 -52 -86 -40
-121 27 -27 51 -24 81 9 98 42 20 61 10 93 -50z"
          />
          <path
            d="M1012 7348 c-7 -7 -12 -25 -12 -42 0 -29 28 -60 159 -179 23 -21 39
-42 36 -47 -4 -6 -66 -10 -140 -10 -125 0 -136 -1 -155 -22 -23 -25 -26 -60
-7 -76 8 -7 80 -8 216 -3 196 7 205 9 223 30 35 45 25 69 -69 160 -49 46 -115
110 -148 143 -62 59 -81 68 -103 46z"
          />
          <path
            d="M9536 7194 c-19 -19 -20 -21 -2 -72 19 -54 13 -58 -149 -119 -127
-47 -130 -49 -133 -81 -3 -26 1 -34 22 -43 21 -10 36 -8 83 10 32 12 93 35
136 51 l79 29 24 -26 c13 -14 24 -31 24 -38 0 -21 28 -38 54 -31 30 7 39 41
21 80 -8 17 -28 67 -44 111 -54 146 -75 170 -115 129z"
          />
          <path
            d="M862 6931 c-14 -8 -71 -165 -92 -249 -16 -70 -7 -94 33 -90 27 3 34
9 45 43 20 62 23 62 152 23 36 -11 79 -26 97 -34 17 -8 47 -14 66 -14 31 0 36
4 42 30 4 16 4 34 0 40 -11 17 -56 36 -155 65 -137 39 -142 43 -134 112 6 48
4 58 -11 69 -22 16 -25 17 -43 5z"
          />
          <path
            d="M9512 6771 c-97 -33 -152 -103 -152 -193 0 -140 88 -237 217 -238
163 0 274 154 217 302 -23 58 -59 96 -119 124 -60 28 -93 29 -163 5z m135 -93
c44 -16 78 -83 69 -133 -10 -51 -56 -92 -114 -100 -53 -7 -86 2 -119 34 -19
18 -23 33 -23 82 0 55 3 64 30 89 42 39 98 49 157 28z"
          />
          <path
            d="M9660 6323 c-184 -32 -190 -34 -206 -59 -15 -22 -15 -26 1 -50 16
-24 20 -26 70 -19 31 3 56 2 59 -3 3 -6 -15 -37 -40 -71 -50 -66 -64 -104 -57
-145 12 -62 50 -38 135 87 22 32 47 61 55 64 17 7 90 -30 157 -79 45 -32 62
-35 74 -10 20 38 -6 77 -85 131 -35 23 -63 46 -63 51 0 5 12 12 28 16 77 17
97 37 81 82 -7 19 -15 22 -66 21 -32 -1 -96 -8 -143 -16z"
          />
          <path
            d="M1016 6194 c-21 -55 6 -81 72 -68 37 7 48 14 50 31 4 28 -32 53 -79
53 -24 0 -39 -5 -43 -16z"
          />
          <path
            d="M663 6078 c-36 -40 -53 -86 -54 -146 -2 -112 56 -174 149 -159 47 8
76 38 102 106 35 94 44 106 70 106 17 0 29 -9 38 -28 17 -35 4 -79 -39 -133
-34 -43 -34 -45 -11 -74 27 -33 68 -17 108 42 49 72 53 187 10 253 -20 31 -72
55 -116 55 -48 0 -105 -59 -130 -134 -24 -71 -30 -81 -50 -88 -39 -13 -52 66
-19 117 30 47 30 50 20 78 -13 34 -49 36 -78 5z"
          />
          <path
            d="M9630 5919 c-114 -10 -136 -26 -126 -94 3 -22 9 -82 12 -132 6 -73
11 -96 26 -110 18 -16 22 -16 46 -2 27 15 27 17 27 120 0 104 0 104 25 104 34
0 50 -36 50 -115 0 -73 10 -90 51 -90 35 0 39 13 39 125 0 78 3 94 17 99 29
11 44 -19 57 -111 7 -49 16 -94 20 -101 4 -7 20 -12 36 -12 40 0 44 20 38 182
-4 97 -8 132 -19 139 -17 10 -167 9 -299 -2z"
          />
          <path
            d="M611 5666 c-18 -21 -16 -83 2 -104 9 -10 42 -36 72 -58 58 -42 65
-56 38 -78 -10 -8 -43 -34 -73 -58 -48 -39 -55 -49 -58 -84 -2 -25 2 -45 10
-51 21 -17 368 -26 398 -10 29 14 36 44 18 70 -11 14 -32 18 -115 20 -57 2
-105 6 -108 9 -8 7 5 38 16 38 5 0 17 7 26 15 10 8 25 20 34 27 39 30 33 53
-26 103 -30 26 -55 51 -55 56 0 5 46 9 103 9 56 0 107 4 113 8 18 12 25 48 15
76 l-11 26 -194 0 c-153 0 -196 -3 -205 -14z"
          />
          <path
            d="M9563 5513 c-50 -9 -56 -69 -8 -91 14 -7 59 -12 100 -12 41 0 76 -4
79 -8 8 -13 -21 -41 -118 -112 -89 -66 -111 -99 -85 -125 10 -9 65 -14 202
-17 204 -5 227 0 227 47 0 36 -35 54 -109 54 -64 0 -89 10 -77 30 4 6 41 36
82 67 41 31 81 66 89 77 18 26 19 61 3 75 -13 10 -341 23 -385 15z"
          />
          <path
            d="M828 5153 c-31 -20 -58 -78 -58 -126 0 -48 -19 -107 -36 -114 -27
-10 -49 24 -47 73 1 25 7 52 13 59 27 32 -18 96 -56 81 -23 -9 -54 -86 -54
-136 0 -77 16 -122 54 -157 31 -28 43 -33 87 -33 44 0 55 4 80 31 32 35 49 84
49 147 0 55 14 82 44 82 45 0 60 -89 26 -153 -25 -46 -25 -59 0 -82 40 -36 91
3 120 92 24 78 -19 209 -80 240 -35 18 -110 15 -142 -4z"
          />
          <path
            d="M9490 5091 c-54 -15 -25 -75 40 -82 32 -4 70 9 71 24 3 27 -4 52 -15
59 -13 9 -62 9 -96 -1z"
          />
          <path
            d="M9498 4708 c-16 -12 -22 -29 -19 -55 2 -24 33 -42 89 -53 31 -6 69
-13 85 -16 43 -9 32 -32 -30 -62 -75 -35 -79 -56 -24 -121 23 -27 41 -52 41
-55 0 -11 -65 -6 -131 11 -63 16 -68 16 -93 0 -44 -29 -28 -90 27 -101 92 -19
232 -50 278 -62 31 -8 63 -12 71 -9 9 4 22 24 31 46 18 45 14 53 -66 151 -20
25 -37 50 -37 55 0 6 33 25 73 43 39 17 80 39 89 47 23 20 34 79 19 97 -7 8
-56 24 -109 36 -53 13 -131 31 -174 41 -90 22 -99 23 -120 7z"
          />
          <path
            d="M1043 4677 c-12 -7 -47 -46 -78 -87 -30 -41 -61 -78 -68 -82 -21 -13
-56 4 -149 75 -48 37 -82 34 -86 -8 -4 -54 14 -75 111 -130 39 -23 33 -40 -20
-56 -44 -13 -48 -17 -51 -47 -5 -55 11 -65 94 -58 39 4 86 11 103 16 18 5 63
12 101 16 l70 7 1 -34 c0 -19 8 -65 19 -104 10 -38 15 -73 12 -76 -8 -7 -106
-39 -210 -69 -83 -24 -105 -49 -83 -96 11 -25 15 -26 59 -21 43 6 145 33 217
58 17 6 47 15 69 20 70 17 79 26 74 72 -8 71 -68 247 -88 259 -14 9 -16 16 -9
30 7 13 6 27 -3 46 -12 25 -19 27 -71 28 -32 1 -60 4 -63 7 -6 5 31 60 68 101
29 32 41 74 32 108 -11 37 -21 42 -51 25z"
          />
          <path
            d="M9465 4201 c-81 -14 -135 -62 -168 -151 -23 -63 -21 -112 7 -168 51
-99 118 -137 230 -130 93 6 137 32 185 112 35 57 36 165 1 221 -29 48 -34 53
-85 86 -44 29 -108 40 -170 30z m102 -120 c66 -30 91 -98 59 -160 -56 -108
-236 -61 -236 62 0 32 7 46 39 78 45 45 73 49 138 20z"
          />
          <path
            d="M1035 3898 c-27 -12 -66 -27 -85 -35 -66 -26 -85 -41 -88 -68 -7 -52
50 -83 94 -50 10 8 26 15 34 15 9 0 48 14 89 31 87 37 111 33 147 -20 22 -34
24 -42 13 -62 -24 -45 -27 -47 -201 -119 -70 -29 -78 -35 -78 -58 0 -15 9 -38
20 -52 l19 -25 72 25 c112 38 209 91 242 131 42 53 49 138 16 204 -13 26 -38
60 -57 76 -30 27 -38 29 -110 28 -53 -1 -93 -7 -127 -21z"
          />
          <path
            d="M9210 3791 c-27 -51 -3 -80 105 -126 69 -30 79 -41 43 -50 -23 -5
-59 -13 -168 -39 -30 -8 -63 -17 -73 -21 -19 -8 -32 -47 -23 -70 5 -14 149
-87 230 -116 20 -7 36 -16 36 -20 0 -4 10 -9 23 -12 12 -3 37 -11 55 -18 32
-13 35 -12 53 10 24 29 24 63 2 83 -10 9 -45 27 -78 41 -85 36 -83 50 10 67
136 25 194 56 195 102 0 21 -38 58 -60 58 -9 0 -25 7 -36 15 -10 8 -26 15 -35
15 -8 0 -24 8 -35 18 -26 23 -174 82 -207 82 -16 0 -30 -8 -37 -19z"
          />
          <path
            d="M1288 3542 c-14 -9 -38 -31 -52 -48 -19 -23 -37 -33 -66 -37 -51 -7
-68 -21 -92 -75 -24 -54 -21 -69 44 -200 63 -127 72 -131 172 -77 255 135 276
149 276 176 0 22 -79 176 -112 219 -43 55 -118 74 -170 42z m110 -158 c38 -57
39 -69 11 -84 -27 -15 -52 7 -75 66 -14 36 -14 47 -4 59 19 22 31 15 68 -41z
m-166 -61 c8 -10 23 -33 32 -52 17 -35 10 -50 -21 -51 -15 0 -63 69 -63 91 0
33 28 39 52 12z"
          />
          <path
            d="M9037 3418 c-7 -13 -37 -63 -66 -111 -29 -48 -55 -105 -58 -125 -4
-32 -2 -39 19 -51 33 -17 70 -11 83 14 44 86 82 145 92 145 7 0 17 -9 23 -21
9 -16 8 -24 -3 -37 -31 -36 -69 -124 -63 -149 7 -26 46 -49 70 -40 8 3 35 42
60 85 41 71 49 79 71 74 14 -2 25 -7 25 -10 0 -2 -21 -44 -47 -93 -41 -76 -45
-91 -36 -112 13 -27 65 -41 87 -23 24 19 136 233 136 259 0 30 -4 33 -205 142
-156 85 -167 88 -188 53z"
          />
          <path
            d="M1710 3043 c-30 -11 -50 -37 -50 -64 0 -32 23 -59 51 -59 15 0 18 -5
13 -24 -7 -30 16 -77 68 -135 21 -25 37 -52 36 -60 -7 -34 -35 -19 -91 49 -58
71 -78 81 -118 60 -35 -19 -24 -68 31 -140 51 -67 56 -83 27 -88 -17 -3 -46
25 -99 100 -23 31 -34 38 -61 38 -74 0 -77 -54 -6 -148 124 -165 134 -173 185
-141 20 12 43 29 52 39 10 9 44 37 78 62 149 112 168 130 160 161 -10 41 -169
237 -192 237 -22 0 -25 17 -7 49 14 24 15 35 7 48 -11 18 -56 27 -84 16z"
          />
          <path
            d="M8766 2958 c-30 -42 -18 -68 58 -120 50 -35 65 -62 117 -216 12 -37
28 -72 33 -79 17 -19 55 -4 71 28 20 38 19 65 -5 134 -11 32 -20 62 -20 66 0
5 38 8 84 6 78 -2 86 0 106 23 12 14 20 34 18 50 -3 21 -9 26 -48 32 -25 3
-72 7 -105 8 -92 3 -141 17 -194 55 -56 41 -93 45 -115 13z"
          />
          <path
            d="M1965 2597 c-22 -18 -72 -64 -110 -103 -39 -38 -80 -76 -91 -84 -29
-22 -54 -61 -54 -86 0 -13 12 -37 26 -54 29 -34 17 -33 162 -14 59 8 74 1 62
-31 -5 -13 -12 -54 -16 -90 -6 -58 -4 -68 17 -100 19 -27 31 -35 56 -35 27 0
50 19 167 134 114 112 136 138 136 163 0 35 -27 63 -59 63 -19 0 -129 -89
-139 -112 -6 -13 -32 -9 -32 5 0 6 5 30 10 52 5 22 7 47 4 56 -7 25 -45 37
-102 31 -69 -6 -68 9 3 73 30 27 60 63 67 79 11 27 9 31 -20 57 -18 16 -36 29
-40 28 -4 0 -25 -15 -47 -32z"
          />
          <path
            d="M8482 2590 c-29 -12 -45 -53 -31 -83 5 -12 23 -31 39 -43 63 -44 170
-147 170 -162 0 -10 -9 -28 -20 -42 -11 -14 -20 -29 -20 -35 0 -5 -4 -16 -9
-24 -7 -11 -37 15 -125 106 -121 126 -151 144 -186 114 -35 -29 -35 -64 -1
-97 17 -16 31 -37 31 -46 0 -16 -11 -18 -92 -19 -51 0 -101 -3 -110 -7 -10 -4
-43 -32 -74 -62 -54 -53 -55 -55 -49 -96 l6 -41 -58 -39 c-32 -21 -63 -44 -69
-52 -8 -11 -15 -12 -32 -3 -26 14 -77 14 -102 1 -10 -5 -27 -25 -39 -45 -12
-20 -28 -35 -39 -35 -23 0 -52 -30 -52 -54 0 -20 20 -60 55 -112 14 -20 25
-40 25 -45 0 -4 -54 11 -120 34 -98 34 -124 39 -147 31 -23 -8 -29 -16 -31
-48 -3 -34 -6 -37 -25 -31 -80 26 -176 1 -247 -65 -115 -106 -49 -279 103
-268 28 2 61 9 72 15 31 16 82 25 89 15 13 -21 -43 -55 -96 -59 -58 -4 -88
-24 -88 -60 0 -59 73 -84 169 -57 51 14 69 25 105 65 35 39 44 57 49 100 7 60
-10 93 -67 128 -39 25 -118 28 -156 6 -26 -15 -82 -20 -93 -9 -7 8 11 46 27
56 6 4 37 8 69 8 67 0 91 10 110 46 l13 25 40 -66 c21 -36 49 -83 62 -104 12
-21 40 -57 62 -80 l40 -41 32 19 c30 16 33 22 33 63 -1 35 -7 53 -32 83 -18
21 -30 42 -27 47 8 13 43 9 82 -8 21 -9 52 -22 70 -30 51 -22 88 -18 124 15
l33 29 -47 69 c-26 38 -54 85 -62 105 -9 19 -23 38 -32 42 -9 4 -14 9 -11 12
3 4 -5 21 -18 39 -24 30 -32 55 -19 55 4 0 104 -55 164 -91 8 -5 29 -15 46
-23 17 -7 50 -26 73 -40 56 -36 110 -29 142 16 20 27 21 35 11 81 -6 29 -14
69 -17 90 -3 20 -10 37 -15 37 -6 0 -10 10 -10 23 0 21 -22 127 -36 175 -6 20
-3 22 28 22 49 0 65 -17 71 -79 4 -29 12 -60 19 -69 26 -31 102 -72 135 -72
42 0 116 47 196 124 45 43 57 62 57 86 0 33 2 35 30 20 16 -9 27 -3 67 38 47
47 59 59 141 155 50 57 55 96 17 121 -34 22 -40 21 -84 -19 -21 -19 -42 -35
-46 -35 -4 0 -35 24 -68 53 -34 28 -72 61 -86 72 -13 11 -29 25 -35 31 -12 11
-52 35 -58 33 -2 0 -13 -4 -26 -9z m-26 -434 c18 -29 13 -42 -33 -80 -70 -59
-108 12 -40 75 39 35 52 36 73 5z m-406 -277 c0 -33 0 -33 -35 -17 -31 14 -31
21 -2 41 28 19 37 13 37 -24z"
          />
          <path
            d="M2217 2122 c-119 -120 -137 -141 -137 -170 0 -47 31 -75 75 -66 35 6
35 6 35 -29 0 -21 6 -39 14 -44 8 -4 32 -23 53 -41 127 -108 178 -142 208
-140 59 6 73 93 20 122 -11 6 -23 15 -27 20 -7 10 16 62 29 68 5 1 21 23 38
47 16 24 35 45 42 48 7 3 13 9 13 15 0 5 11 26 25 46 30 43 31 63 8 84 -40 35
-61 32 -107 -14 -23 -24 -58 -65 -77 -93 -39 -58 -79 -105 -90 -105 -4 0 -20
11 -36 24 -16 14 -43 26 -61 28 l-32 3 67 75 c38 41 86 93 109 115 22 22 43
49 47 58 12 31 -27 87 -60 87 -10 0 -79 -61 -156 -138z"
          />
          <path
            d="M2719 1927 c-7 -12 -9 -46 -6 -84 5 -63 5 -63 -22 -63 -15 0 -45 -14
-68 -30 -96 -70 -88 -216 15 -276 23 -14 42 -29 42 -34 0 -5 26 -22 58 -38 31
-17 56 -35 55 -41 -2 -6 5 -7 20 -3 12 5 51 52 91 112 38 57 72 98 74 91 2 -7
0 -16 -5 -20 -5 -3 -24 -36 -41 -73 -18 -37 -37 -70 -42 -73 -14 -9 -12 -71 3
-83 7 -6 25 -15 40 -21 46 -18 78 22 191 235 10 19 20 33 22 31 3 -2 0 -53 -6
-113 -5 -60 -10 -134 -10 -166 0 -51 3 -59 31 -82 40 -34 86 -34 125 -1 16 14
34 25 41 25 6 0 13 4 15 9 2 5 32 33 68 61 36 28 83 66 105 83 93 75 101 92
60 132 -27 28 -70 32 -99 10 -29 -22 -50 -19 -110 15 -55 31 -80 54 -82 74 0
6 -2 20 -2 31 -4 43 -157 99 -204 74 -15 -8 -18 -6 -18 15 0 17 -11 34 -34 51
-30 23 -38 25 -58 14 -20 -11 -44 -35 -71 -73 -16 -24 -45 33 -52 104 -6 64
-10 73 -39 94 -46 34 -74 39 -87 13z m312 -285 c-6 -2 -11 -12 -11 -22 0 -9
-7 -23 -15 -30 -24 -20 -19 12 8 53 15 24 23 30 26 18 2 -8 -2 -17 -8 -19z
m-261 -14 c45 -26 53 -60 20 -78 -24 -13 -70 8 -94 42 -14 20 -14 24 1 40 21
23 26 23 73 -4z m545 -227 c0 -7 -10 -20 -22 -28 -22 -15 -23 -14 -23 16 0 28
3 32 23 29 12 -2 22 -9 22 -17z"
          />
          <path
            d="M6952 1480 c-33 -14 -49 -54 -33 -84 7 -12 13 -37 14 -55 2 -31 -1
-34 -64 -59 -36 -15 -74 -34 -84 -42 -15 -12 -18 -12 -28 5 -7 11 -16 42 -22
70 -14 70 -43 86 -117 63 -29 -9 -80 -24 -113 -33 -79 -23 -135 -46 -135 -57
0 -4 -24 -8 -54 -8 -70 0 -80 -13 -72 -84 11 -81 -12 -83 -99 -9 -50 42 -74
49 -130 33 -39 -11 -45 -16 -45 -40 0 -21 12 -38 50 -70 49 -41 61 -65 39 -72
-15 -5 -29 -86 -22 -128 8 -46 30 -90 46 -90 7 0 23 -9 35 -21 33 -30 76 -33
179 -10 90 19 143 45 162 79 8 14 13 15 30 5 29 -18 69 -16 136 7 32 11 65 20
74 20 9 0 33 9 54 20 21 11 42 18 48 14 14 -8 39 15 33 31 -5 12 -1 12 20 2
14 -7 26 -16 26 -21 0 -5 6 -3 13 3 8 6 27 12 43 14 16 2 49 13 74 24 25 12
73 33 108 49 53 24 62 31 62 53 -1 14 -7 37 -15 51 -8 14 -14 35 -15 47 0 12
-7 28 -15 37 -8 8 -15 20 -15 26 0 6 -11 36 -25 66 -14 30 -25 60 -25 67 0 7
-10 32 -23 57 -24 48 -49 59 -95 40z m-360 -274 c-17 -5 -32 -12 -32 -17 0 -4
-13 -10 -30 -14 -51 -11 -110 -45 -110 -63 -1 -24 -29 27 -30 53 0 18 6 20 50
18 32 -1 56 4 65 13 7 8 24 14 37 15 13 0 32 4 43 8 11 5 24 6 30 3 5 -4 -5
-10 -23 -16z m416 -49 c2 -10 -2 -17 -10 -17 -7 0 -35 -12 -63 -25 -27 -14
-55 -25 -61 -25 -11 0 -56 -44 -52 -51 2 -2 -3 2 -9 10 -7 8 -13 32 -13 52 0
35 2 37 33 37 17 0 55 9 82 20 57 23 89 23 93 -1z m-348 -96 c0 -16 -44 -38
-90 -46 -25 -4 -60 -19 -78 -33 -29 -22 -35 -23 -48 -10 -18 18 -28 68 -14 68
5 0 19 -9 31 -21 21 -21 21 -21 34 -1 10 13 31 21 66 25 29 4 57 11 63 17 12
12 36 13 36 1z m-370 -97 c0 -28 -53 -55 -85 -44 -33 12 -31 48 2 60 15 5 35
14 43 19 20 12 40 -6 40 -35z"
          />
          <path
            d="M3936 1363 c-28 -44 -41 -83 -28 -83 5 0 14 -11 20 -24 8 -19 20 -25
49 -28 34 -3 38 -6 45 -38 4 -19 14 -64 22 -100 9 -36 16 -80 16 -97 0 -18 4
-33 9 -33 5 0 12 -27 16 -61 6 -54 11 -63 39 -80 17 -10 43 -19 58 -19 27 0
98 54 98 76 0 6 7 14 15 18 8 3 15 12 15 21 0 8 4 15 9 15 5 0 18 15 30 33 11
17 26 41 33 52 7 11 15 22 18 25 11 10 78 106 89 128 13 24 8 32 -38 64 -22
15 -28 15 -59 2 -19 -8 -40 -22 -47 -31 -9 -12 -22 -15 -56 -10 -24 3 -45 11
-47 16 -2 6 -14 11 -27 11 -34 0 -55 10 -55 27 0 27 -56 73 -89 73 -27 0 -31
3 -31 28 0 35 -16 52 -52 52 -21 0 -33 -9 -52 -37z m291 -317 c-4 -9 -11 -16
-17 -16 -11 0 -14 33 -3 44 11 10 26 -11 20 -28z"
          />
          <path
            d="M4610 1181 c-20 -6 -26 -17 -37 -69 -7 -34 -17 -71 -23 -81 -5 -11
-10 -50 -10 -88 0 -82 -11 -106 -36 -82 -12 13 -24 15 -51 8 -20 -4 -40 -14
-44 -21 -14 -21 -10 -94 5 -107 7 -6 42 -14 77 -17 35 -4 69 -10 74 -14 6 -5
51 -11 101 -15 117 -9 133 -2 130 60 -3 55 -13 66 -69 80 l-42 10 4 94 c1 52
9 112 17 134 8 21 11 43 8 48 -3 5 -1 9 5 9 9 0 27 -43 51 -122 6 -21 16 -40
21 -43 5 -4 9 -17 9 -29 0 -21 14 -63 40 -121 5 -11 12 -35 15 -52 9 -46 54
-76 102 -68 52 8 63 19 106 110 8 17 21 36 30 44 10 7 17 22 17 32 0 11 4 19
9 19 4 0 16 21 26 46 9 25 19 43 21 41 3 -2 7 -31 9 -63 6 -81 24 -125 71
-177 48 -53 72 -60 206 -59 160 1 168 7 168 128 0 133 -20 312 -37 326 -17 14
-236 14 -273 0 -14 -6 -42 -26 -62 -46 -36 -35 -37 -35 -27 -10 13 37 6 51
-37 69 -50 20 -50 20 -94 -24 l-38 -39 -84 14 c-45 8 -84 14 -85 14 -2 0 -3 4
-3 10 0 25 -45 60 -76 60 -42 0 -84 -19 -84 -38 0 -10 -5 -8 -17 6 -21 24 -57
33 -93 23z m836 -167 c18 -5 22 -15 26 -62 8 -91 1 -119 -33 -126 -31 -6 -88
14 -108 38 -19 23 -16 94 6 118 29 33 66 44 109 32z"
          />
          <path d="M557 4073 c-9 -9 -9 -53 1 -53 4 0 7 14 8 30 1 32 1 33 -9 23z" />
          <path
            d="M902 3164 c4 -21 22 -23 26 -1 2 10 -3 17 -13 17 -10 0 -15 -6 -13
-16z"
          />
          <path
            d="M220 347 c0 -58 0 -58 27 -55 33 4 42 32 18 56 -9 9 -22 26 -30 37
-13 18 -14 15 -15 -38z"
          />
          <path
            d="M10543 335 c-27 -19 -20 -45 13 -45 20 0 24 5 24 30 0 34 -6 36 -37
15z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
